<template>
  <!-- eslint-disable vue/max-attributes-per-line -->
  <span v-if="href" class="benefit-doc-preview d-inline-flex align-center">
    <v-icon small color="primary" class="mr-1">{{ fileIcon }}</v-icon>
    <a
      :href="href"
      target="_blank"
      rel="noopener noreferrer"
      class="text-decoration-none primary--text text-body-2"
      :title="displayName"
    >{{ shortName }}</a>
    <v-btn
      icon
      x-small
      :href="href"
      target="_blank"
      rel="noopener noreferrer"
      :aria-label="`Открыть документ ${displayName}`"
      class="ml-1"
    >
      <v-icon x-small>{{ mdiOpenInNew }}</v-icon>
    </v-btn>
  </span>
  <span v-else class="text--disabled">—</span>
</template>

<script>
import {
  mdiFilePdfBox,
  mdiFileImageOutline,
  mdiFileWordOutline,
  mdiFileOutline,
  mdiOpenInNew,
} from '@mdi/js'
import { buildLkDocumentHref } from '../utils'

function extIcon(url) {
  if (!url) return mdiFileOutline
  const ext = String(url).split('.').pop().toLowerCase()
  if (ext === 'pdf') return mdiFilePdfBox
  if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(ext)) return mdiFileImageOutline
  if (['doc', 'docx'].includes(ext)) return mdiFileWordOutline
  return mdiFileOutline
}

function decodeFileName(name) {
  if (!name) return ''
  try {
    return decodeURIComponent(String(name).replace(/\+/g, '%20'))
  } catch (e) {
    return String(name)
  }
}

export default {
  name: 'BenefitDocumentPreview',
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  data() {
    return { mdiOpenInNew }
  },
  computed: {
    href() {
      return buildLkDocumentHref(this.url)
    },
    displayName() {
      if (!this.url) return ''
      const cleanUrl = String(this.url).split('?')[0].split('#')[0]
      const parts = cleanUrl.split('/')
      const rawName = parts[parts.length - 1] || 'документ'
      return decodeFileName(rawName)
    },
    shortName() {
      const n = this.displayName
      return n.length > 24 ? `${n.slice(0, 20)}…` : n
    },
    fileIcon() {
      return extIcon(this.url)
    },
  },
}
</script>
